module.exports = __webpack_public_path__ + "img/chain_staff.b76e0526.png";